
import { application } from "./application";

// Auto-imported local controllers
import Controller0 from "./ace_editor_controller.js";
import Controller1 from "./active_link_controller.js";
import Controller2 from "./autofocus_controller.js";
import Controller3 from "./bundle_toggle_controller.js";
import Controller4 from "./calendar_dropdown_controller.js";
import Controller5 from "./checkbox_observer_controller.js";
import Controller6 from "./checkbox_select_all_controller.js";
import Controller7 from "./choices_controller.js";
import Controller8 from "./choose_or_create_controller.js";
import Controller9 from "./click_controller.js";
import Controller10 from "./clipboard_controller.js";
import Controller11 from "./cmd_enter_controller.js";
import Controller12 from "./color_field_controller.js";
import Controller13 from "./color_scheme_controller.js";
import Controller14 from "./create_event_controller.js";
import Controller15 from "./cropper_controller.js";
import Controller16 from "./current_item_controller.js";
import Controller17 from "./custom_field_form_controller.js";
import Controller18 from "./custom_metadata_validation_controller.js";
import Controller19 from "./default_to_placeholder_controller.js";
import Controller20 from "./dependent_checkboxes_controller.js";
import Controller21 from "./disable_click_controller.js";
import Controller22 from "./disable_other_element_controller.js";
import Controller23 from "./dismiss_getting_started_controller.js";
import Controller24 from "./docs_api_token_controller.js";
import Controller25 from "./docs_code_tabs_controller.js";
import Controller26 from "./docs_nav_controller.js";
import Controller27 from "./docs_search_controller.js";
import Controller28 from "./dynamic_turbo_frame_controller.js";
import Controller29 from "./edit_venue_controller.js";
import Controller30 from "./example_promotion_codes_controller.js";
import Controller31 from "./flash_controller.js";
import Controller32 from "./html_template_form_controller.js";
import Controller33 from "./inactive_overlay_controller.js";
import Controller34 from "./integration_field_mapping_controller.js";
import Controller35 from "./modal_controller.js";
import Controller36 from "./nested_form_controller.js";
import Controller37 from "./new_data_indicator_controller.js";
import Controller38 from "./open_modal_controller.js";
import Controller39 from "./palette_color_controller.js";
import Controller40 from "./password_strength_controller.js";
import Controller41 from "./placeholder_override_controller.js";
import Controller42 from "./places_autocomplete_controller.js";
import Controller43 from "./popover_hint_controller.js";
import Controller44 from "./preserve_ids_in_url_controller.js";
import Controller45 from "./price_and_tax_controller.js";
import Controller46 from "./remote_modal_controller.js";
import Controller47 from "./reset_to_default_controller.js";
import Controller48 from "./reveal_controller.js";
import Controller49 from "./scroll_to_selected_controller.js";
import Controller50 from "./search_form_controller.js";
import Controller51 from "./slug_controller.js";
import Controller52 from "./sortable_controller.js";
import Controller53 from "./status_controller.js";
import Controller54 from "./sync_inputs_controller.js";
import Controller55 from "./tablist_controller.js";
import Controller56 from "./tax_rate_attachment_controller.js";
import Controller57 from "./textarea_autogrow_controller.js";
import Controller58 from "./time_controller.js";
import Controller59 from "./time_dropdown_controller.js";
import Controller60 from "./tooltip_controller.js";
import Controller61 from "./uppy_controller.js";
import Controller62 from "./venue_field_controller.js";
import Controller63 from "./web_authn_controller.js";
import Controller64 from "./widget_form_controller.js";

application.register("ace-editor", Controller0);
application.register("active-link", Controller1);
application.register("autofocus", Controller2);
application.register("bundle-toggle", Controller3);
application.register("calendar-dropdown", Controller4);
application.register("checkbox-observer", Controller5);
application.register("checkbox-select-all", Controller6);
application.register("choices", Controller7);
application.register("choose-or-create", Controller8);
application.register("click", Controller9);
application.register("clipboard", Controller10);
application.register("cmd-enter", Controller11);
application.register("color-field", Controller12);
application.register("color-scheme", Controller13);
application.register("create-event", Controller14);
application.register("cropper", Controller15);
application.register("current-item", Controller16);
application.register("custom-field-form", Controller17);
application.register("custom-metadata-validation", Controller18);
application.register("default-to-placeholder", Controller19);
application.register("dependent-checkboxes", Controller20);
application.register("disable-click", Controller21);
application.register("disable-other-element", Controller22);
application.register("dismiss-getting-started", Controller23);
application.register("docs-api-token", Controller24);
application.register("docs-code-tabs", Controller25);
application.register("docs-nav", Controller26);
application.register("docs-search", Controller27);
application.register("dynamic-turbo-frame", Controller28);
application.register("edit-venue", Controller29);
application.register("example-promotion-codes", Controller30);
application.register("flash", Controller31);
application.register("html-template-form", Controller32);
application.register("inactive-overlay", Controller33);
application.register("integration-field-mapping", Controller34);
application.register("modal", Controller35);
application.register("nested-form", Controller36);
application.register("new-data-indicator", Controller37);
application.register("open-modal", Controller38);
application.register("palette-color", Controller39);
application.register("password-strength", Controller40);
application.register("placeholder-override", Controller41);
application.register("places-autocomplete", Controller42);
application.register("popover-hint", Controller43);
application.register("preserve-ids-in-url", Controller44);
application.register("price-and-tax", Controller45);
application.register("remote-modal", Controller46);
application.register("reset-to-default", Controller47);
application.register("reveal", Controller48);
application.register("scroll-to-selected", Controller49);
application.register("search-form", Controller50);
application.register("slug", Controller51);
application.register("sortable", Controller52);
application.register("status", Controller53);
application.register("sync-inputs", Controller54);
application.register("tablist", Controller55);
application.register("tax-rate-attachment", Controller56);
application.register("textarea-autogrow", Controller57);
application.register("time", Controller58);
application.register("time-dropdown", Controller59);
application.register("tooltip", Controller60);
application.register("uppy", Controller61);
application.register("venue-field", Controller62);
application.register("web-authn", Controller63);
application.register("widget-form", Controller64);
